/** @jsx jsx */
import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import ContentTree from './contentTree';
import { onMd, onSm, onXxlg } from '../../styles/responsive';
import { getNavigationData } from '../Navigation/Navigation';
import { colors, headerHeight, pageLayout, prettyScrollBar } from '../../theme';

const Sidebar = styled.div`
  flex-direction: column;
  // width: ${pageLayout.sidebarWidth};
  height: 100%;
  display: flex;
  overflow-y: hidden;
  align-items: stretch;
  flex-direction: column;
  ${onMd} {
    width: ${pageLayout.sidebarWidth};
  }
  ${onSm} {
    margin-left: 10px;
  }
  ${onXxlg} {
    width: ${pageLayout.sidebarWidthXxlg};
    padding-left: 150px;
  }
`;

const SidebarMain = styled.div`
  overflow-y: auto;
  overflow: hidden;
  -webkit-overflow-scrolling: hidden;
  &:hover,
  &:focus {
    overflow-y: overlay;
    -webkit-overflow-scrolling: touch;
  }
  background: ${colors.background};
  width: 100%;
  margin: 0;
  display: block;
  padding-top: 20px;
`;

export const SidebarNavigation = ({ location, showOnSm }: { location: any; showOnSm: boolean }) => {
  const edges = getNavigationData();
  return (
    <aside
      css={{
        bottom: 0,
        position: 'fixed',
        flex: `0 0 ${pageLayout.sidebarWidth}`,
        [onMd]: {
          top: headerHeight
        },
        [onSm]: {
          display: showOnSm ? 'block' : 'none',
          width: '100%',
          height: 'auto',
          borderRight: 'none',
          position: 'relative'
        }
      }}
    >
      <Sidebar>
        <SidebarMain css={prettyScrollBar}>
          <ContentTree edges={edges} location={location} />
          <div css={{ height: '35px' }} />
        </SidebarMain>
      </Sidebar>
    </aside>
  );
};
